import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import { SIDEBAR_WIDTH } from '@/components/NewSidebar';
import { NavigationButton } from '@/components/NewSidebar/components/NavigationButton';
import { noticeableWidgetId } from '@/environment';
import { useAnalytics } from '@/services/analytics';
import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import confetti from '../../images/confetti.svg';

const ButtonWrapper = styled.div`
    padding: 0 1.6rem;
`;

const StyledButton = styled(NavigationButton)`
    width: 100%;
`;

export const WhatsNew = () => {
    const mixpanel = useAnalytics();
    const [isWhatsNewOpenOnce, setWhatsNewOpenOnce] = useState(false);

    const handleOpen = async () => {
        setWhatsNewOpenOnce(true);
        await noticeable?.render('widget', noticeableWidgetId);
        noticeable?.do('widget:open', noticeableWidgetId);
    };
    const handleClose = async () => {
        noticeable?.do('widget:close', noticeableWidgetId);
    };

    useEffect(() => {
        return () => {
            handleClose();
        };
    }, []);

    useEffect(() => {
        if (isWhatsNewOpenOnce) {
            mixpanel?.track('whats-new', { event: 'click' });
        }
    }, [isWhatsNewOpenOnce]);

    const onWhatsNewClick = async () => {
        await handleOpen();
    };

    return (
        <>
            <ButtonWrapper>
                <StyledButton id="sidebar-whats-new" onClick={onWhatsNewClick}>
                    <MaskedIcon src={confetti} size="24px" id="noticeable-widget" />
                    New in D-ID
                </StyledButton>
            </ButtonWrapper>
            <Global
                styles={css`
                    .noticeable-widget-view {
                        right: unset !important;
                        left: calc(${SIDEBAR_WIDTH} - 36px) !important;
                    }
                `}
            />
        </>
    );
};
